import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { WellbeingTypes } from 'constants/wellbeing';
import { useWellbeingContent, useTagMap } from 'hooks/useWellbeingContent';
import { DEFAULT_CATEGORY } from 'pages/WellBeingContent/types';
import type { Wellbeing, Tag } from 'types/wellbeing';

const getCategories = (content: Wellbeing[], tagMap: Map<string, Tag>): string[] => {
  if (!content) return [];

  const uniqueTagIds = [...new Set(content.flatMap(item => item.tags))];
  const tagNames = uniqueTagIds.map(tagId => tagMap.get(tagId)?.id ?? tagId);
  return [DEFAULT_CATEGORY, ...tagNames];
};

export const CategoryFilter = ({
  selectedCategory,
  setSelectedCategory,
  content: contentProp,
}: {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  content?: Wellbeing[];
}): React.ReactElement => {
  const { id } = useParams();
  const type = contentProp ? undefined : WellbeingTypes[id as keyof typeof WellbeingTypes];
  const { data: contentFromApi } = useWellbeingContent(type as WellbeingTypes);
  const content = contentProp ?? contentFromApi;
  const tagMap = useTagMap();
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);

  return (
    <div className="flex flex-wrap gap-2 overflow-x-auto pb-2">
      {content &&
        getCategories(content, tagMap).map(category => (
          <Button
            key={category}
            variant={selectedCategory === category ? 'primary' : 'terciary'}
            onClick={() => setSelectedCategory(category)}
            className="border"
          >
            {category === DEFAULT_CATEGORY
              ? t('WellBeingContent.Categories.all')
              : tagMap.get(category)?.name}
          </Button>
        ))}
    </div>
  );
};
